import { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";

// Scan button in Scanning.jsx:
// bottom: 20px, height: 6rem (96px)
// So button top edge = 20 + 96 = 116px from bottom
const DASHED_LINE_HEIGHT = 60;
const BUBBLE_PADDING = 20; // breathing room between bubble bottom and line top
const TOOLTIP_BOTTOM = 116 + DASHED_LINE_HEIGHT + BUBBLE_PADDING; // ~196px from bottom

export const ScannerTooltipView = () => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      {/* Dark overlay - non-interactive so scan button still works beneath */}
      {isVisible && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.7)",
            zIndex: 1050,
            pointerEvents: "none",
          }}
        />
      )}

      {/* Info / Close button - top left */}
      <Box
        sx={{
          position: "fixed",
          top: 12,
          left: 12,
          zIndex: 1200,
        }}
      >
        <IconButton
          onClick={() => setIsVisible((prev) => !prev)}
          sx={{
            width: 50,
            height: 50,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "white",
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          }}
        >
          {isVisible
            ? <CloseIcon />
            : <InfoOutlinedIcon />
          }
        </IconButton>
      </Box>

      {/* Tooltip bubble + dashed line */}
      {isVisible && (
        <Box
          sx={{
            position: "fixed",
            bottom: `${TOOLTIP_BOTTOM}px`,
            left: 0,
            right: 0,
            zIndex: 1200,
            px: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box sx={{ position: "relative", display: "flex", justifyContent: "center" }}>
            {/* Text bubble */}
            <Typography
              sx={{
                color: "yellow",
                fontWeight: "bold",
                textAlign: "center",
                border: "2px solid yellow",
                borderRadius: 2,
                p: 2,
                maxWidth: 280,
              }}
            >
              Point camera at image and tap the scan button
            </Typography>

            {/* Dashed line pointing down to center of scan button */}
            <Box
              sx={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                height: `${DASHED_LINE_HEIGHT}px`,
                borderLeft: "2px dashed yellow",
              }}
            />
          </Box>
        </Box>
      )}
    </>
  );
};